// extracted by mini-css-extract-plugin
module.exports =  {"list":"_0d624b9a27--list--kaJLh"};